import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { ShipCardLayout } from 'src/components/molecules/ShipCardLayout'
import ColorButton from 'src/components/atoms/ColorButton'

import { Typography } from 'src/components/atoms/Typography'

const shipContents = [
    {
        id: 1,
        title: 'FIRM BONDさまに、オンボーディングのコツを伺わせていただきました！',
        text:
            'こんにちは、ネクスウェイの吉川です。\nみなさまもご覧になられていましたでしょうか、\n1か月ほど前の、寺岡さん（﻿@ilpXSwjOd﻿）からのこちらの投稿…！驚異的なリテンション向上の成果とその秘訣が語られていました。是非直接お話を伺ってみたいと思ってから、数週間…迷いに迷っていましたが駒谷さん、金子さんからの後押しもあり、MTGのお願いをさせていただきました',
        url:'https://community.commmune.com/view/post/0/99423'
    },
    {
        id: 2,
        title: 'イベント後の投稿を盛り上げるために試行錯誤しています',
        text:
            '皆さまこんにちは。リクルートの藤咲と申します！私たちは従業員サーベイツールの「Geppo」というサービスを販売しており、ユーザー様同士の交流を目的としてコミュニティを始めました。導入から半年未満なのですが、ユーザーに投稿してもらうハードルがかなり高く、',
        url:'https://community.commmune.com/view/post/0/145291'
    },
    {
        id: 3,
        title: 'ユーザーインタビューって大事だった！！！',
        text:
            'ユーザーインタビューをもとにサイトデザインを変更はじめまして！アライドアーキテクツの上田といいます。今回SHIPには初めての投稿となります。弊社では法人向けの動画制作ツール「LetroStudio」を提供しております。',
        url:'https://community.commmune.com/view/post/0/139447'
    },
    {
        id: 4,
        title: 'しくじり⇒気づき。',
        text:
            '金子さん、先日はお時間頂きありがとう御座いました！わたくしの話に共感頂けたことが嬉しかったですし、金子さんの考えや過去のご経験談をお聞かせいただき大変勉強になりました。またこのような機会がありましたら是非お話聞かせてください！',
        url:'https://community.commmune.com/view/post/0/97893'
    },
    {
        id: 5,
        title: '一人でやらない、コミュニティ運営のテーマで登壇しました',
        text:
            'こんにちは、ネクスウェイの吉川と申します。先日、このスレッドでもご紹介いただいておりましたが12/23にSHIPメンバーのカケハシ伊藤さんと共に登壇してきました！（初登壇で、ドキドキwでした）',
        url:'https://community.commmune.com/view/post/0/90912'
    },
    {
        id: 6,
        title: 'コミュニティ導入においての成功事例・気づき',
        text:
            '皆さんこんにちは！（株）ファームボンドの寺岡です。本日は弊社コミュニティ運用においての成功事例を紹介させて頂きたいと思います。弊社は会員数約3,000名の株式投資の塾を運営しております。会員様向けにコミュニティを解放しておりますが、',
        url:'https://community.commmune.com/view/post/0/90172'
    },
    
] 

const TopTeam = () => {
    return (
        <Container>
            <ContentsWrapper>
                <HeadingBorder heading="COMMUNITY" />
                <HeadTitle as="h2">
                    <Line>
                        <NoLineBreak inlineIfMobile>コミュニティを</NoLineBreak>
                        <NoLineBreak inlineIfMobile>見てみる</NoLineBreak>
                    </Line>
                    <Line>
                        <NoLineBreak inlineIfMobile>-commmuneの運営する</NoLineBreak>
                        <NoLineBreak inlineIfMobile>コミュニティ"SHIP"-</NoLineBreak>
                    </Line>
                </HeadTitle>
                <PointCardLayoutWrapper>
                    <HeadNotification>*投稿の一部を抜粋</HeadNotification>
                    <ShipCardLayout>
                        {shipContents.map(shipContent => {
                            const text = shipContent.text.slice( 0, 100 ) + '...'
                        return (
                            <Card href={shipContent.url} target="_blank">
                                <Title>{shipContent.title}</Title>
                                <Text>{text}</Text>
                            </Card>
                        )
                        })}
                    </ShipCardLayout>
                </PointCardLayoutWrapper>
                <ButtonWrapper>
                    <ColorButton text="実際のコミュニティを見てみる" to="https://community.commmune.com/view/box?boxId=KSiuLrQCJ&categoryIndex=0" arrow target="_blank"/>
                </ButtonWrapper>
            </ContentsWrapper>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    padding: 120px 0;
    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
        padding: 48px 0;
    }
`

const Line = styled.span`
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        display: block;
    }
`
const HeadNotification = styled.div`
    font-size: ${Styles.fontSize[200]};
    font-weight: ${Styles.fontWeight.normal};
    color: ${Styles.color.primary[400]};
    margin: 0 0 ${Styles.spacing[6]} 0;
`

const PointCardLayoutWrapper = styled.div`
    margin: ${Styles.spacing[11]} 0 0;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin: ${Styles.spacing[11]} 0 0;
    }
`

const Card = styled.a`
    border:  1px solid ${Styles.color.border[400]};
    border-radius: 10px;
    padding: ${Styles.spacing[6]};
    text-decoration: none;
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 15%);
`

const Title = styled.div`
    font-weight: ${Styles.fontWeight.bold};
    font-size: ${Styles.fontSize[500]};
    color: ${Styles.color.primary[400]};
`

const Text = styled.div`
    margin-top: ${Styles.spacing[5]};
    font-size: ${Styles.fontSize[300]};
    color: ${Styles.color.grayscale[400]};
    line-height: 1.5;
`
const ShipButton = styled.a`
    background-color: ${Styles.color.secondary[400]};
`
const ButtonWrapper = styled.div`
    margin: ${Styles.spacing[11]} 0 0;
    text-align: center;
`


export default TopTeam
